'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Testimonial = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    text-align: center;\n\n    & > img {\n        display: inline-block;\n        margin: 0 auto;\n        border-radius: 50%;\n    }\n    & > div {\n        color: #24a9bd;\n        font-size: 1.2em;\n        margin: 1em 0;\n    }\n    & > i {\n        font-size: .9em;\n    }\n    & > p {\n        padding: 1em;\n        margin-top: 2em;\n        margin-bottom: 0;\n        background: white;\n        position: relative;\n\n        &:before {\n            position: absolute;\n            bottom: 100%;\n            left: calc(50% - 1em);\n            content: \' \';\n            border: solid transparent 1em;\n            border-bottom-color: white;\n        }\n    }\n'], ['\n    text-align: center;\n\n    & > img {\n        display: inline-block;\n        margin: 0 auto;\n        border-radius: 50%;\n    }\n    & > div {\n        color: #24a9bd;\n        font-size: 1.2em;\n        margin: 1em 0;\n    }\n    & > i {\n        font-size: .9em;\n    }\n    & > p {\n        padding: 1em;\n        margin-top: 2em;\n        margin-bottom: 0;\n        background: white;\n        position: relative;\n\n        &:before {\n            position: absolute;\n            bottom: 100%;\n            left: calc(50% - 1em);\n            content: \' \';\n            border: solid transparent 1em;\n            border-bottom-color: white;\n        }\n    }\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _LazyImg = require('./LazyImg');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */


/*::
type Props = {|
    name: string,
    pic: string,
    job: string,
    children: string,
|}
*/
var Testimonial /*: ComponentType<Props> */ = exports.Testimonial = (0, _styledComponents2.default)(function (props) {
    return React.createElement(
        'div',
        { className: props.className },
        React.createElement(_LazyImg.LazyImg, { src: props.pic, alt: props.name, height: 120 }),
        React.createElement(
            'div',
            null,
            props.name
        ),
        React.createElement(
            'i',
            null,
            props.job
        ),
        React.createElement(
            'p',
            null,
            props.children
        )
    );
})(_templateObject);
Testimonial.displayName = 'Testimonial';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/Testimonial.js
// module id = 647
// module chunks = 0